import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MdCancel, MdCheckCircle, MdChevronLeft } from "react-icons/md";

import { useStyles } from "../../../layout/Styles";

const propTypes = {
  promptText: PropTypes.string.isRequired,
  dataText: PropTypes.object,
  buttons: PropTypes.shape({
    yesText: PropTypes.string.isRequired,
    noText: PropTypes.string.isRequired,
    onSelect: PropTypes.function,
  }),
  children: PropTypes.object,
  hideButtons: PropTypes.bool,
  hideNoButton: PropTypes.bool,
};

function PromptButtons(props) {
  const styles = useStyles();
  return (
    <Box mt={1} mx={1.5}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="start"
        className="prompt-btn"
        spacing={1}
        mb={1}
      >
        {props.promptText && (
          <Grid item xs={12} mb={1}>
            <Typography variant="h5" color="#1a247e" fontWeight="600">
              {props.promptText}
            </Typography>
            {props.dataText}
            {props.children}
          </Grid>
        )}

        {!props.hideButtons && (
          <>
            <Grid item xs={12} sm={6}>
              <button
                className={"prompt confirm"}
                value={"yes"}
                onClick={(e) => {
                  e.preventDefault();
                  props.buttons.onSelect("yes");
                }}
              >
                <MdCheckCircle className={styles.iconBadge} />
                {props.buttons.yesText}
              </button>
            </Grid>
            {!props.hideNoButton && (
              <Grid item xs={12} sm={6}>
                <button
                  className={"prompt not-confirm"}
                  onClick={(e) => {
                    e.preventDefault();
                    props.buttons.onSelect("no");
                  }}
                >
                  <MdCancel className={styles.iconBadge} />
                  {props.buttons.noText}
                </button>
              </Grid>
            )}
          </>
        )}
        {props.hideButtons && (
          <Grid item xs={12} sm={12}>
            <button
              className={"prompt completed"}
              value={"yes"}
              onClick={(e) => {
                e.preventDefault();
                props.buttons.onSelect("yes");
              }}
            >
              <MdChevronLeft className={styles.iconBadge} />
              {"Back"}
            </button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

PromptButtons.prototype = propTypes;
export default PromptButtons;
